// import Swiper JS
import { register } from 'swiper/element/bundle';
import Swiper from "swiper";
// import Swiper styles
import "swiper/css";

// import function to register Swiper custom elements
// register Swiper custom elements
register();






document.addEventListener("DOMContentLoaded", function () {
	// Initialize Swiper without navigation configured
	const sliderGridItem = new Swiper(".sliderGridItem", {
		loop: true, // Keep looping enabled if desired
	});

	// Manually add event listeners to navigation buttons
	const prevButton = document.querySelector('.sliderGridItem-prev');
	const nextButton = document.querySelector('.sliderGridItem-next');

	// Check if buttons exist and add event listeners
	if (prevButton) {
		prevButton.addEventListener('click', function() {
			sliderGridItem.slidePrev();
		});
	}

	if (nextButton) {
		nextButton.addEventListener('click', function() {
			sliderGridItem.slideNext();
		});
	}

});



document.addEventListener("DOMContentLoaded", function () {

  const swiperEl = document.querySelector('.car-gallery');
	
	// Manually add event listeners to navigation buttons
	const prevButton = document.querySelector('.car-gallery-prev');
	const nextButton = document.querySelector('.car-gallery-next');

	// Check if buttons exist and add event listeners
	if (prevButton) {
		prevButton.addEventListener('click', function() {
			swiperEl.swiper.slidePrev();
		});
	}

	if (nextButton) {
		nextButton.addEventListener('click', function() {
			swiperEl.swiper.slideNext();
		});
	}

});

document.addEventListener("DOMContentLoaded", function () {

  const swiper = new Swiper('.videoSlider', {
    slidesPerView: 'auto',
    spaceBetween: 16,
		loop:true,
		centeredSlides:true,
    on: {
      init: function () {
        console.log('Swiper initialized');
        addClickEvents(this);
        playVideoInActiveSlide(this);
      },
      slideChange: function () {
        playVideoInActiveSlide(this);
      }
    }
  });

  function playVideoInActiveSlide(swiperInstance) {
    swiperInstance.slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    const video = activeSlide.querySelector('video');
    if (video) {
      video.play();
    }
  }

  function addClickEvents(swiperInstance) {
    swiperInstance.slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        swiperInstance.slideTo(index);
      });
    });
  }

});
